import React, { useState, useEffect, useRef } from 'react';
import './UserDropdown.css';

const UserDropdown = ({ users, selectedUserId, currentUserId, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  // Close dropdown on Escape key
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (userId) => {
    onSelect(userId);
    setIsOpen(false);
  };

  const getSelectedUser = () => {
    if (selectedUserId === currentUserId) {
      return 'My Picks';
    }
    const user = users.find(u => u.id === selectedUserId);
    return user ? (user.display_name || user.username) : 'Select User';
  };

  const isCurrentUser = (userId) => {
    return userId === selectedUserId;
  };

  return (
    <div className="user-dropdown" ref={dropdownRef}>
      <button
        className="user-dropdown-button"
        onClick={handleToggle}
        aria-haspopup="true"
        aria-expanded={isOpen}
      >
        <span className="user-icon">👤</span>
        <span className="user-dropdown-text">{getSelectedUser()}</span>
        <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>▼</span>
      </button>

      {isOpen && (
        <div className="user-dropdown-menu">
          <div className="user-dropdown-section">
            <button
              className={`user-dropdown-item ${isCurrentUser(currentUserId) ? 'selected' : ''}`}
              onClick={() => handleSelect(currentUserId)}
            >
              {isCurrentUser(currentUserId) && <span className="check-icon">✓</span>}
              <span className="user-item-text">My Picks</span>
            </button>
          </div>

          <div className="user-dropdown-divider"></div>

          <div className="user-dropdown-section">
            {users
              .filter(u => u.id !== currentUserId)
              .sort((a, b) => (a.display_name || a.username).localeCompare(b.display_name || b.username))
              .map(user => (
                <button
                  key={user.id}
                  className={`user-dropdown-item ${isCurrentUser(user.id) ? 'selected' : ''}`}
                  onClick={() => handleSelect(user.id)}
                >
                  {isCurrentUser(user.id) && <span className="check-icon">✓</span>}
                  <span className="user-item-text">{user.display_name || user.username}</span>
                </button>
              ))
            }
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDropdown;
